import { VARIANTS_ACTIONS } from '../contants';
import { PayloadType } from '../actions/Variants'


type Value = {
  stringValue?: string;
  longValue?: string;
  boolValue?: boolean;
  doubleValue?: number;
};

type JsonValue = {
  abKey?: string;
} & Record<string, unknown>


export type VariantType = {
  details: string;
  entityId: string;
  feature: string;
  featureName: string;
  project?: string;
  reason?: string;
  variation?: string;
  value?: Value;
  jsonValue?: JsonValue;
}

type State = { variantList: VariantType[], isLoading?: boolean }

export type ActionPayload = {
  type: string;
  payload: PayloadType
}

const getJsonValue = (value?: string) => {
  try {
    return JSON.parse(value || '{}') || ''
  } catch(e) {
    return {}
  }
}


const initialState: State = { variantList: [], isLoading: false }

export default function variants(
  state: State =  initialState,
  action: ActionPayload,
) {
  switch (action.type) {
    case VARIANTS_ACTIONS.UPDATE: {
      return {
        ...state,
        isLoading: action.payload.isLoading,
        variantList: action.payload.variantList?.map(({ value , ...other}) => {
          const jsonValue = getJsonValue(value?.stringValue)

          return {
            ...other,
            value,
            jsonValue
          }
        })
      }
    }

    case VARIANTS_ACTIONS.SET_LOADING: {
      return {
        ...state,
        isLoading: action.payload.isLoading
      }
    }
    case VARIANTS_ACTIONS.RESET: {
      return initialState
    }
    default:
      return state;
  }
}
